import React, { Component } from 'react'
import { Helmet } from "react-helmet"
import PropTypes from 'prop-types'

// JS
import { WEBSITE_HEAD } from '../../utils/constants'

class PageInfo extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        description: PropTypes.string
    }

    render() {
        return (
            <Helmet>
                <title>{WEBSITE_HEAD} {this.props.title}</title>
                {this.props.description ? <meta name="description" content={this.props.description} /> : null }
            </Helmet>
        )
    }
}

export default PageInfo;





// WEBPACK FOOTER //
// ./src/components/pageinfo/PageInfo.js